import { useTheme } from 'styled-components';
import { Close } from "../../assets/Close";
import { PillContainer, PillDecorator, PillDelete, PillLabel } from "./Pill.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @component
 * @name Pill
 * @description A pill component with possibility to be deletable. It can have a left and right decorator, but not both. If have both, the left decorator will be ignored.
 * @param label - The label of the pill.
 * @param size - The size of the pill.
 * @param variant - The variant of the pill.
 * @param color - The color of the pill.
 * @param labelColor - The color of the label.
 * @param leftDecorator - The left decorator of the pill.
 * @param rightDecorator - The right decorator of the pill.
 * @param disabled - If the pill is disabled.
 * @param deletable - If the pill is deletable.
 * @param onClick - The function to be called when the pill is clicked.
 * @param onDelete - The function to be called when the delete button is clicked.
 */
const Pill = props => {
  const {
    label,
    size,
    variant,
    color,
    labelColor,
    leftDecorator,
    rightDecorator,
    disabled,
    deletable,
    onClick,
    onDelete,
    ...rest
  } = props;
  const theme = useTheme();
  const closeIconSize = size === 'sm' ? 'md' : 'sm';
  return /*#__PURE__*/_jsxs(PillContainer, {
    ...rest,
    type: "button",
    size: size,
    variant: variant,
    color: color,
    clickable: !!onClick,
    disabled: disabled,
    onClick: e => {
      e.stopPropagation();
      onClick?.();
    },
    children: [deletable && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PillLabel, {
        labelColor: labelColor,
        size: size,
        children: label
      }), /*#__PURE__*/_jsx(PillDelete, {
        onClick: e => {
          e.stopPropagation();
          onDelete?.();
        },
        children: /*#__PURE__*/_jsx(Close, {
          size: closeIconSize,
          color: theme.colors.neutralL4
        })
      })]
    }), !deletable && /*#__PURE__*/_jsxs(_Fragment, {
      children: [leftDecorator && !rightDecorator && /*#__PURE__*/_jsx(PillDecorator, {
        size: size,
        children: leftDecorator
      }), /*#__PURE__*/_jsx(PillLabel, {
        labelColor: labelColor,
        size: size,
        children: label
      }), rightDecorator && /*#__PURE__*/_jsx(PillDecorator, {
        size: size,
        children: rightDecorator
      })]
    })]
  });
};
export { Pill };